module.exports = __webpack_public_path__ + "img/4.c14740e7.png";